module.exports = __webpack_public_path__ + "img/piattaformagiallo.c1c75321.png";